module.exports = __webpack_public_path__ + "static/media/023.6bf1a868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/023.jpg
// module id = 496
// module chunks = 0